import { Injectable, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { DatepickerDialogComponent } from '../components/datepicker-dialog/datepicker-dialog.component';
import { TextDialogComponent } from '../components/text-dialog/text-dialog.component';
import { CustomDialogSettings } from '../model/CustomDialogSettings';
import { DialogAlignment } from '../model/DialogAlignment';
import { ShowInfoTextDialogComponentComponent } from '../components/show-info-text-dialog-component/show-info-text-dialog-component.component';
import { DisplayTextComponent } from '../components/display-text/display-text.component';

@Injectable({
  providedIn: 'root'
})
export class CustomDialogService {

  constructor(
    private dialogService: DialogService,
    private translateService: TranslateService
  ) { }

  actionWithConfirmation(confirmationText: string, okCallback: () => void, dialogDiv:ViewContainerRef, useTextWithoutTranslation = false, confirmationHtmlBodyText = null) {

    const dialogRef = this.dialogService.open({
      content: ConfirmationDialogComponent,
      maxWidth: '98%',
      maxHeight: '98%',
      appendTo: dialogDiv
    });

    const dialogObject = dialogRef.content.instance;

    let message = confirmationText;
    if(!useTextWithoutTranslation){
      message = this.translateService.instant(message);
    }

    dialogObject.question = message;
    dialogObject.htmlQuestionBody = confirmationHtmlBodyText;

    dialogRef.result.subscribe((r) => {

      if (r['text'] == 'OK' && !!okCallback) {
        okCallback();
      }
    });
  }

  actionWithTextDisplay(text: string, okCallback: () => void, dialogDiv:ViewContainerRef, useTextWithoutTranslation = false) {

    const dialogRef = this.dialogService.open({
      content: ShowInfoTextDialogComponentComponent,
      appendTo: dialogDiv
    });

    const dialogObject = dialogRef.content.instance;

    let message = text;
    if(!useTextWithoutTranslation){
      message = this.translateService.instant(message);
    }

    dialogObject.question = message;

    dialogRef.result.subscribe((r) => {

      if (r['text'] == 'OK' && !!okCallback) {
        okCallback();
      }
    });
  }


  actionWithDateSelection(label: string, okCallback: (date) => void, currentDate:Date = null, dateOnly = false) {

    const dialogRef = this.dialogService.open({
      content: DatepickerDialogComponent
    });

    const dialogObject = dialogRef.content.instance;
    dialogObject.label = label;
    dialogObject.dateOnly = dateOnly;

    if(currentDate){
      dialogObject.selectedDate = currentDate;
    }

    dialogRef.result.subscribe((r) => {

      if (r['text'] == 'OK' && !!okCallback) {
        okCallback(r['selectedDate']);
      }
    });
  }

  actionWithTextSelection(label: string, okCallback: (string) => void, currentText = '', useTextArea = false,  dialogDiv: ViewContainerRef) {

    const dialogRef = this.dialogService.open({
      content: TextDialogComponent,
      minWidth: '30%',
      maxWidth: '98%',
      appendTo: dialogDiv
    });

    const dialogObject = dialogRef.content.instance;
    dialogObject.label = label;
    
    if(useTextArea){
    dialogObject.useTextArea = useTextArea;
    }

    if(currentText){
      dialogObject.selectedText = currentText;
    }
   
    dialogRef.result.subscribe((r) => {

      if (r['text'] == 'OK' && !!okCallback) {
        okCallback(r['selectedText']);
      }
    });
  }

   showText(label: string, okCallback: (string) => void, currentText = '', formatXmlContent ,  dialogDiv: ViewContainerRef) {

    const dialogRef = this.dialogService.open({
      content: DisplayTextComponent,
      maxWidth: '70%',
      maxHeight: '70%',
      appendTo: dialogDiv
    });

    const dialogObject = dialogRef.content.instance;
    dialogObject.label = label;
    
    if(currentText){
      dialogObject.selectedText = currentText;
    }

    if(formatXmlContent){
      dialogObject.formatXmlContent = formatXmlContent;
    }
   
    dialogRef.result.subscribe((r) => {

      if (r['text'] == 'OK' && !!okCallback) {
        okCallback(r['selectedText']);
      }
    });
  }


  showDialog(settings: CustomDialogSettings) : DialogRef{

    const dialogRef = this.dialogService.open({
      title:settings.title,
      content: settings.content,
      minWidth: settings.minWidth,
      minHeight: settings.minHeight,
      maxWidth: settings.maxWidth,
      maxHeight:settings.maxHeight,
      appendTo: settings.appendTo,
 
    });

    if(settings.dialogAlignment == DialogAlignment.top){
      const dialogWrapper = dialogRef.dialog.location.nativeElement as HTMLElement;
    
      const dialogElement = dialogWrapper.querySelector("[role|=dialog]")as HTMLElement ;
      dialogElement.style.position = "fixed";
      dialogElement.style.top = "10px";
    }

    if(settings.dialogAlignment == DialogAlignment.bottom){
      const dialogWrapper = dialogRef.dialog.location.nativeElement as HTMLElement;
    
      const dialogElement = dialogWrapper.querySelector("[role|=dialog]")as HTMLElement ;
      dialogElement.style.position = "fixed";
      dialogElement.style.bottom = "10px";
    }

    if(settings.dialogInputs){
      const dialogObject = dialogRef.content.instance;
      Object.entries(settings.dialogInputs).forEach(
        ([key, value]) => {
          dialogObject[key] = value
        });
      }

    dialogRef.result.subscribe((r) => {
     if(settings.resultCallback){
      settings.resultCallback(r);
     }
     });

     return dialogRef;
  }


}
